import { toaster } from "../components/toaster";
import { DefaultService } from "../generated";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const useInvoiceRegister = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["invoiceRegister"],
    mutationFn: (invoiceUuid: string) =>
      DefaultService.fakturInvoicesViewsInvoiceRegister({ invoiceUuid }),
    onSuccess: () => {
      toaster.success({ title: "Faktura registrert!" });
      queryClient.invalidateQueries({ queryKey: ["invoiceDetail"] });
      queryClient.invalidateQueries({ queryKey: ["invoiceList"] });
    },
  });
};
